import { useEffect, useRef } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { MessageCard } from "./MessageCard";
import { Message } from "../../types/generated";
import { FixedSizeList as List } from "react-window";
import { Button } from "../ui/button";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface MessageListProps {
  title: string;
  messages: Message[];
  onSendClick?: (id: number) => void;
  onDeleteClick?: (id: number) => void;
  isDraft?: boolean;
  hasMore: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
}

export const MessageList = ({
  title,
  messages,
  onSendClick,
  onDeleteClick,
  isDraft = false,
  hasMore,
  isLoadingMore,
  onLoadMore,
}: MessageListProps) => {
  const { t } = useTranslation();
  
  const Row = ({
    index,
    style,
  }: {
    index: number;
    style: React.CSSProperties;
  }) => (
    <div style={style} className="px-4">
      <MessageCard
        key={messages[index].id}
        message={messages[index]}
        onSendClick={onSendClick}
        onDeleteClick={onDeleteClick}
        isDraft={isDraft}
      />
    </div>
  );

  return (
    <Card className="shadow-sm mb-6">
      <CardHeader>
        <CardTitle className="text-xl">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {messages && messages.length > 0 ? (
          <>
            <List
              height={600}
              width="100%"
              itemCount={messages.length}
              itemSize={180}
              className="scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
            >
              {Row}
            </List>
            {hasMore && (
              <div className="mt-4 text-center">
                <Button
                  variant="outline"
                  onClick={() => onLoadMore()}
                  disabled={isLoadingMore}
                >
                  {isLoadingMore ? (
                    <>
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      {t("common.loading")}
                    </>
                  ) : (
                    t("message.load_more")
                  )}
                </Button>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            {t("message.no_messages_found")}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
